import { render, staticRenderFns } from "./MenuActions-comp.vue?vue&type=template&id=5ddcd406&scoped=true&"
import script from "./MenuActions-comp.vue?vue&type=script&lang=js&"
export * from "./MenuActions-comp.vue?vue&type=script&lang=js&"
import style0 from "./MenuActions-comp.vue?vue&type=style&index=0&id=5ddcd406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcd406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VIcon,VMenu})
